import {
  EClickableSize,
  EClickableTarget,
  EClickableVariants,
} from '../at-clickable/at-clickable.types';
import { IAtLinkProps } from './at-link.types';

export const atLinkMockData: IAtLinkProps = {
  label: 'click here',
  href: '/',
  target: EClickableTarget.BLANK,
  key: '123456',
  variant: EClickableVariants.DIMINUTIVE,
  size: EClickableSize.LG,
};
